export default "__VITE_ASSET__Now5POtX__"